import React, { useState, useEffect } from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { logout, setProfile } from "../features/authSlice";
import { MdAddLink, MdLogout, MdSearch, MdPerson } from "react-icons/md";
import { SiGooglemeet } from "react-icons/si";
import HomeRoutes from "./HomeRoutes";
import "flowbite/dist/flowbite.min.js";
import { BACKEND } from "../config/configEnvs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Snowfall from "react-snowfall";
import TwilioPhone from "../components/twilioPhone/TwilioPhone";
import VerificationTrabajadorDialog from "../components/dialogs/VerificationTrabajadorDialog";

const snowflake1 = document.createElement("img");
const snowflake2 = document.createElement("img");
const snowflake3 = document.createElement("img");
const snowflake4 = document.createElement("img");
const snowflake5 = document.createElement("img");
const snowflake6 = document.createElement("img");
snowflake1.src = "/images/christmas/candy-cane.png";
snowflake2.src = "/images/christmas/christmas-bell.png";
snowflake3.src = "/images/christmas/christmas-tree.png";
snowflake4.src = "/images/christmas/gift.png";
snowflake5.src = "/images/christmas/hat.png";
snowflake6.src = "/images/christmas/christmas-ornament.png";

const images = [
  snowflake1,
  snowflake2,
  snowflake3,
  snowflake4,
  snowflake5,
  snowflake6,
];

const Home = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [links, setLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const location = useLocation();
  const [openVerificationModal, setOpenVerificationModal] = useState(false);

  const dispatch = useDispatch();
  const [redirect, setRedirect] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const profileRedux = useSelector((state) => state.auth.profile);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/links`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        setLinks(data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchLinks();
  }, []);

  const fetchProfileUser = async () => {
    if (user) {
      try {
        const response = await axios.get(
          `${BACKEND}/api/trabajadores/${user.id}`
        );
        dispatch(setProfile(response.data));
        if (
          response.data?.verificacionHabilitada &&
          !response.data?.verificado
        ) {
          setOpenVerificationModal(true);
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    fetchProfileUser();
  }, []);
  // Filtra los enlaces en función de las subáreas a las que el usuario tiene acceso
  useEffect(() => {
    if (user?.subarea) {
      const filtered = links
        .map((link) => {
          const filteredElementos = link.elemento.filter((element) => {
            return (
              !element.access ||
              element.access.length === 0 ||
              element.access.some((access) => access.subarea === user.subarea)
            );
          });

          // Si quedan elementos después del filtrado, conserva el enlace
          if (filteredElementos.length > 0) {
            return {
              ...link,
              elemento: filteredElementos,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean); // Elimina los enlaces nulos

      setFilteredLinks(filtered);
    } else {
      // Si el usuario no tiene una subárea definida, muestra todos los enlaces
      setFilteredLinks([...links]);
    }
  }, [links, user]);

  const handleLogout = async () => {
    dispatch(logout());
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/"} />;
  }

  if (user == null) {
    return <Navigate to={"/"} />;
  }

  const handleClick = () => {
    setIsClicked(!isClicked);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
  };

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
      setSelectedSubcategory(null);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <ToastContainer />

      <TwilioPhone />
      {/* <Snowfall
          color="red"
          radius={[8, 25]}
          images={images}
          wind={[-1, -0.5]}
          // Applied to the canvas element
          // Controls the number of snowflakes that are created (default 150)
          snowflakeCount={150}
        /> */}
      {profileRedux &&
        profileRedux?.verificacionHabilitada &&
        !profileRedux?.verificado && (
          <VerificationTrabajadorDialog
            open={openVerificationModal}
            profile={profileRedux}
            setOpen={setOpenVerificationModal}
          />
        )}
      <nav className="bg-[#ff6400]">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between text-white mx-auto p-4">
          <div className="flex items-center">
            <Link className="ml-6 md:ml-2 lg:ml-4 xl:ml-6 mr-4" to="/home">
              <img className="h-12 w-12" src="/images/logo-blanco.png" alt="" />
            </Link>
          </div>
          <button
            data-collapse-toggle="navbar-multi-level"
            type="button"
            className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 "
            aria-controls="navbar-multi-level"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>

          <div
            className="z-50 hidden my-4 text-base list-none divide-y  rounded shadow bg-zinc-700 divide-zinc-600"
            id="dropdown-user"
          >
            <div className="px-4 py-3" role="none">
              <p className="text-sm text-white" role="none">
                {user.name}
              </p>
              <p
                className="text-sm font-medium  truncate text-zinc-300"
                role="none"
              >
                {user.email}
              </p>
            </div>
            <ul className="py-1" role="none">
              <li>
                <a
                  href="/home/dashboard"
                  className="block px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                  role="menuitem"
                >
                  Dashboard
                </a>
              </li>
              <li>
                <button
                  onClick={handleLogout}
                  className="block px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                  role="menuitem"
                >
                  Sign out
                </button>
              </li>
            </ul>
          </div>
          <div
            className="hidden w-full lg:block lg:w-auto"
            id="navbar-multi-level"
          >
            <ul className="flex flex-col text-sm lg:items-center p-4 lg:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 lg:flex-row lg:space-x-4 xl:space-x-6 lg:mt-0 lg:border-0 lg:bg-transparent ">
              <li>
                <Link
                  to="/home"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname === "/home" ? "font-bold" : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/home/marcar-asistencia"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname === "/home/marcar-asistencia" ||
                    location.pathname === "/home/registros-asistencia" ||
                    location.pathname === "/home/registros-sshh"
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Asistencia
                </Link>
              </li>
              <li>
                <Link
                  to="/home/tareas"
                  className={`block relative py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/tareas")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  {new Date().toISOString() < "2024-02-04T04:06:04.502Z"}
                  <span
                    style={{ fontSize: "0.5rem" }}
                    className=" absolute -top-1/2 -right-0 bg-yellow-200 w-2 h-2  rounded-full font-light "
                  >
                    {" "}
                  </span>
                  Tareas
                </Link>
              </li>
              <li>
                <Link
                  to="/home/recursos"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/recursos")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Recursos
                </Link>
              </li>
              {/*<li>
                <Link
                  to="/home/proyectos"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/proyectos")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Proyectos
                </Link>
                </li>*/}
              {user?.subarea?.toUpperCase() === "VENTAS" && (
                <li>
                  <Link
                    to="/home/ventas"
                    className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                      location.pathname.startsWith("/home/ventas")
                        ? "font-bold"
                        : " font-normal"
                    }`}
                    aria-current="page"
                  >
                    Ventas
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="/home/clientes"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/clientes")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Clientes
                </Link>
              </li>

              <li>
                <Link
                  to="/home/learning"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/learning")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Team
                </Link>
              </li>
              <li>
                <Link
                  to="/home/reglas"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/rrhh")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Reglas
                </Link>
              </li>

              {user?.area?.toUpperCase() === "COMERCIAL" && (
                <li>
                  <Link
                    to="/home/redes-clientes"
                    className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                      location.pathname.startsWith("/home/redes-clientes")
                        ? "font-bold"
                        : " font-normal"
                    }`}
                    aria-current="page"
                  >
                    Redes clientes
                  </Link>
                </li>
              )}

              {user?.area?.toUpperCase() === "COMERCIAL" &&
                user?.puesto?.toUpperCase() === "EJECUTIVO DE CUENTAS" && (
                  <li>
                    <Link
                      to="/home/afiliacion-clientes"
                      className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                        location.pathname.startsWith(
                          "/home/afiliacion-clientes"
                        )
                          ? "font-bold"
                          : " font-normal"
                      }`}
                      aria-current="page"
                    >
                      Afiliación clientes
                    </Link>
                  </li>
                )}



              {/*<li>
                <Link
                  to="/home/rrhh"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/rrhh")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  RRHH
                </Link>
              </li>
 
              <li>
                <Link
                  to="/home/contabilidad"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/contabilidad")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Contabilidad
                </Link>
                </li>*/}

              {(user?.area?.toUpperCase() === "COMERCIAL" ||
                user?.area?.toUpperCase() === "VENTAS" ||
                (user?.area?.toUpperCase() === "ADMINISTRACION" &&
                  user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS")) && (
                <li>
                  <Link
                    to="/home/cotizaciones"
                    className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                      location.pathname.startsWith("/home/cotizaciones")
                        ? "font-bold"
                        : " font-normal"
                    }`}
                    aria-current="page"
                  >
                    Cotizaciones
                  </Link>
                </li>
              )}

              {((user?.area?.toUpperCase() !== "COMERCIAL" &&
                user?.area?.toUpperCase() !== "VENTAS") ||
                (user?.area?.toUpperCase() === "ADMINISTRACION" &&
                  user?.puesto?.toUpperCase() === "JEFE DE PROYECTOS") ||
                user?.puesto?.toUpperCase() === "EJECUTIVO DE CUENTAS") && (
                <li>
                  <Link
                    to="/home/seguimiento"
                    className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                      location.pathname.startsWith("/home/seguimiento")
                        ? "font-bold"
                        : " font-normal"
                    }`}
                    aria-current="page"
                  >
                    Seguimiento
                  </Link>
                </li>
              )}

              {/*<li>
                <Link
                  to="/home/tutoriales"
                  className={`block py-2 pl-3 pr-4 text-black lg:text-white rounded lg:bg-transparent lg:p-0 ${
                    location.pathname.startsWith("/home/tutoriales")
                      ? "font-bold"
                      : " font-normal"
                  }`}
                  aria-current="page"
                >
                  Tutoriales
                </Link>
                </li>*/}
              <div>
                <button
                  className="flex lg:hidden items-center mt-3 bg-zinc-200 hover:bg-zinc-300 text-black  font-semibold px-3 py-2 rounded"
                  onClick={handleLogout}
                >
                  Sign out
                </button>
              </div>
            </ul>
          </div>

          <div className="hidden lg:flex">
            <Link
              to={"/home/search"}
              className="flex items-center xl:mx-3 2xl:mx-6 hover:bg-[#ff6400] text-white font-semibold p-3 rounded-lg"
            >
              Buscar
              <MdSearch className="h-6 w-6 ml-2" />
            </Link>
          </div>

          <div className="hidden lg:flex items-center">
            <div className="flex items-center">
              <div className="flex items-center ml-3">
                <div className="flex">
                  <button
                    type="button"
                    className="flex text-sm bg-white rounded-full focus:ring-4  focus:ring-zinc-600"
                    aria-expanded="false"
                    data-dropdown-toggle="dropdown-user1"
                  >
                    <span className="sr-only">Open user menu</span>
                    {user.foto?.url ? (
                      <img
                        className="w-8 h-8 rounded-full"
                        src={user.foto.url}
                        alt={user.foto.alt}
                      />
                    ) : (
                      <MdPerson className="text-black h-6 w-6" />
                    )}
                    {console.log(user.foto?.url)}
                  </button>
                </div>
                <div
                  className="z-50 hidden my-4 text-base list-none divide-y  rounded shadow bg-zinc-700 divide-zinc-600"
                  id="dropdown-user1"
                >
                  <div className="px-4 py-3" role="none">
                    <p className="text-sm text-white" role="none">
                      {user.name}
                    </p>
                    <p
                      className="text-sm font-medium  truncate text-zinc-300"
                      role="none"
                    >
                      {user.email}
                    </p>
                  </div>
                  <ul className="py-1" role="none">
                    <li>
                      <a
                        href="/home/editar-perfil"
                        className="block px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                        role="menuitem"
                      >
                        Editar Perfil
                      </a>
                    </li>
                    <li>
                      <a
                        href="/home/registros-asistencia/estadisticas"
                        className="block px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                        role="menuitem"
                      >
                        Mis Estadísticas
                      </a>
                    </li>
                    <li>
                      <a
                        href="/home/lista-trabajadores"
                        className="block px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                        role="menuitem"
                      >
                        Lista de compañeros
                      </a>
                    </li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="flex items-center w-full px-4 py-2 text-sm  text-zinc-300 hover:bg-zinc-600 hover:text-white"
                        role="menuitem"
                      >
                        <MdLogout className="h-4 w-4 mr-2" />
                        Salir
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <h2 className="font-bold p-3">{user.name}</h2>
            </div>
          </div>
        </div>
      </nav>

      <main className="mx-auto p-4">
        <HomeRoutes />
        <div className="fixed bottom-6 right-6 z-50">
          <button
            className="w-16 h-16 bg-[#ff6400] text-white rounded-full flex items-center justify-center cursor-pointer"
            onClick={handleClick}
          >
            <MdAddLink className="h-8 w-8" />
          </button>
          {isClicked && (
            <div>
              <div className="absolute bottom-16 right-0 bg-white rounded shadow-md w-20">
                <ul>
                  {filteredLinks.map((category) => (
                    <li key={category.id} className="w-full p-4">
                      <button
                        className={`flex items-center justify-center h-12 w-12 ${
                          selectedCategory === category.id
                            ? "bg-[#ff6400]"
                            : "bg-zinc-500 hover:bg-[#ff6400]"
                        } text-white rounded-full cursor-pointer`}
                        onClick={() => handleCategoryClick(category.id)}
                      >
                        <SiGooglemeet className="h-6 w-6" />
                      </button>
                      <p className="text-xs text-center">{category.name}</p>
                    </li>
                  ))}
                </ul>
              </div>
              {selectedCategory && (
                <div className="absolute bottom-16 right-20 bg-white rounded shadow-md p-4">
                  <ul className="flex text-black">
                    {filteredLinks
                      .find((category) => category.id === selectedCategory)
                      .elemento.map((subcategory) => (
                        <li key={subcategory.id} className="mx-1.5">
                          <button
                            className={`flex flex-col items-center justify-between p-2 ${
                              selectedSubcategory === subcategory.id
                                ? "bg-[#ff6400]"
                                : "bg-zinc-500 hover:bg-[#ff6400]"
                            } text-white rounded-2xl cursor-pointer`}
                            onClick={() => {
                              window.open(subcategory.link, "_blank");
                            }}
                          >
                            <SiGooglemeet className="h-6 w-6 m-2" />
                            <p className="text-[10px] text-center">
                              {subcategory.name}
                            </p>
                          </button>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Home;
